import { gql } from "urql";
export const CreatePriorityReferralMutation = gql `
    mutation CreatePriorityReferral($input: PriorityReferralInput!) {
        priorityReferrals {
            createPriorityReferral(input: $input) {
                success
            }
        }
    }
`;
export const MoveReferralToPriorityEntryMutation = gql `
    mutation MoveReferralToPriorityEntry($priorityReferralId: String!) {
        priorityReferrals {
            movePriorityReferralToPriorityEntry(
                priorityReferralId: $priorityReferralId
            ) {
                priorityReferralId
            }
        }
    }
`;
export const ArchivePriorityReferralMutation = gql `
    mutation ArchivePriorityReferral($priorityReferralId: String!) {
        priorityReferrals {
            archivePriorityReferral(priorityReferralId: $priorityReferralId) {
                priorityReferralId
                archivedAt
            }
        }
    }
`;
export const RestorePriorityReferralMutation = gql `
    mutation RestorePriorityReferral($priorityReferralId: String!) {
        priorityReferrals {
            restorePriorityReferral(priorityReferralId: $priorityReferralId) {
                priorityReferralId
                archivedAt
            }
        }
    }
`;
